/**
 * Enum for the native Ad user flight
 */
const enum NativeAdUserFlight {
    NoNativeAd,
    PrebidMobileAllInbox,
    PrebidMobileBannerAd,
}

export default NativeAdUserFlight;
